"use client";

import { z } from "zod";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { Section } from "@/common/components-2/section";
import { CmsSectionHeading } from "@/common/components-2/section-heading/cms-section-heading";
import { captureException } from "@/common/helpers/capture-exception";
import type { HranoPage } from "@/payload-types";
import { EmitErrorReport } from "@/services/cms/components/emit-error-report";
import { ContactForm } from "./contact-form";

const contactSectionSchema = z.object({
  heading: z.string(),
  description: z.string(),
});

export function ContactSection(props: HranoPage["cs"]) {
  let propsData: z.infer<typeof contactSectionSchema>;

  try {
    propsData = contactSectionSchema.parse(props);
  } catch (ex) {
    captureException(ex);
    return <EmitErrorReport error={JSON.stringify(ex)} name="Contact section" />;
  }

  const { heading, description } = propsData;

  return (
    <Section classes={{ section: "bg-white-linen-100", container: "max-w-7xl py-14 lg:py-24" }} id="kontakt">
      <div className="md:grid md:grid-cols-[1fr_2fr] lg:grid-cols-[1fr_minmax(696px,_1fr)] lg:gap-2 xl:gap-24">
        <div className="md:pt-8">
          <CmsSectionHeading heading={heading} classes={{ heading: "md:text-left" }} />
          <SanitizedContent as="div" content={description} className="mt-6 text-base" />
        </div>
        <div className="mt-11 rounded-2xl bg-primary-foreground px-6 py-8 md:mt-0 md:p-8">
          <ContactForm className="flex flex-col gap-6 md:grid md:grid-cols-2" />
        </div>
      </div>
    </Section>
  );
}
